<template>
	<div>
		<div class="form">
			<div class="form-img">
				修改房源信息
			</div>
			<div class="form-box">
				<div class="form-box-t">
					您房子的图片
					<small>上传清晰全面的房源图片更容易接到客户的来电哦</small>
				</div>
				<div class="form-box-c" >
					<uploadSingle @change="getPictures" ref="uploadSingle" />
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">选择第几张图片作为房源封面</div>
				<div class="form-box-c">
					<input type="text" class="form-input-c" v-model="formItem.index" />
				</div>
			</div>
			<div class="form-box">
			  <div class="form-box-t">选择类型</div>
			  <div class="form-box-c">
				  <van-radio-group v-model="formItem.type" direction="horizontal">
				    <van-radio name="出租商铺">出租商铺</van-radio>
				    <van-radio name="出售商铺">出售商铺</van-radio>
					<van-radio name="转让店铺">转让店铺</van-radio>
				  </van-radio-group> 
			  </div>
			</div>
			<div class="form-box">
				<div class="form-box-t">选择小区</div>
				<div class="form-box-c">
					<marea :lists="configs.area" :initValue="formItem.community" @change="getXiaoqu" />
				</div>
			</div>
			<van-row :gutter="15">
				<van-col :span="8">
					<div class="form-box">
						<div class="form-box-t">几室</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.shi" />
									<div class="unit">室</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
				<van-col :span="8">
					<div class="form-box">
						<div class="form-box-t">几厅</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.ting" />
									<div class="unit">厅</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
				<van-col :span="8">
					<div class="form-box">
						<div class="form-box-t">几卫</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.wei" />
									<div class="unit">卫</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
			</van-row>
						<van-row :gutter="15">
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">所在楼层</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="text" class="form-input" v-model="formItem.louceng1" /> 
								</div>
							</div>
						</div>
					</div>
				</van-col>
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">总楼层</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="text" class="form-input" v-model="formItem.louceng2" /> 
								</div>
							</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<van-row :gutter="15">
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">面积</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.mianji" />
									<div class="unit">m²</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">{{formItem.type}}(0为面议)</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.price" />
									<div class="unit">元/月</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
			</van-row>

			<!-- <div class="form-box">
				<div class="form-box-t">联系人</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<input type="text" v-model="formItem.contact" />
						</div>
					</div>
				</div>
			</div>

			<div class="form-box">
				<div class="form-box-t">联系电话</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<input type="number" v-model="formItem.phone" />
						</div>
					</div>
				</div>
			</div> -->

			<div class="form-box">
				<div class="form-box-t">房源描述</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<textarea v-model="formItem.content" rows="4"
								placeholder="详细的描述房屋状况，可以帮你快速的出租房源（5-2000个字符）"></textarea>
						</div>
					</div>
				</div>
			</div>

			<div class="form-box">
				<div class="form-box-t">
					<van-button type="info" block @click="post">确认修改</van-button>
					
					<van-button block @click="()=>{$router.push('/user')}" style="margin-top: 10px;">返回我的</van-button>
				</div>
			</div>
		</div>
		<footbar></footbar>
	</div>
</template>

<script>
	window.addEventListener(
		"message",
		function(event) {
			// 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
			var loc = event.data;
			if (loc && loc.module == "locationPicker") {
				//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
				console.log("location", loc);
			}
		},
		false
	);
	var root = process.env.VUE_APP_API_URL;
	import Formtag from "../../commpents/tag";
	import Selecttime from "../../commpents/Selecttime";
	import Ruzhu from "../../commpents/ruzhu";
	import Huxingpicker from "../../commpents/huxingpicker";
	import Loucengpicker from "../../commpents/loucengpicker";
	import Upload from "../../commpents/upload";
	import uploadSingle from "../../commpents/uploadSingle";
	import Footbar from "../../commpents/footbar";
	import District from "../../commpents/district";
	import Community from "../../commpents/community";
	import Wechat from "../../commpents/wechat";
	import Tencentmap from "../../commpents/tencentmap";
	import Marea from "../../commpents/marea";
	import {
		Checkbox,
		CheckboxGroup,
		Card,
		SubmitBar,
		Toast,
		Cell,
		CellGroup,
		Button,
		Tabbar,
		TabbarItem,
		Icon,
		Row,
		Col,
		Tag,
		IndexBar,
		IndexAnchor,
		Radio,
		RadioGroup
	} from "vant";

	export default {
		components: {
			[Radio.name]: Radio,
			[RadioGroup.name]: RadioGroup,
			[Card.name]: Card,
			[Checkbox.name]: Checkbox,
			[SubmitBar.name]: SubmitBar,
			[CheckboxGroup.name]: CheckboxGroup,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[Tag.name]: Tag,
			[IndexBar.name]: IndexBar,
			[IndexAnchor.name]: IndexAnchor,
			Formtag,
			Selecttime,
			Ruzhu,
			Huxingpicker,
			Loucengpicker,
			Upload,
			Footbar,
			District,
			Community,
			Wechat,
			Tencentmap,
			Marea,
			uploadSingle
		},

		data() {
			return {
				getInitUrl: root + "post/init",
				getPostUrl: root + "post/shopedit",
				getViewUrl: root + "shop/view",
				active: "home",
				isactive: false,
				refer: "",
				islogin: 0,
				id: 0,
				peitao: [
					"电视机",
					"冰箱",
					"洗衣机",
					"空调",
					"热水器",
					"床",
					"暖气",
					"宽带",
					"衣柜",
					"天然气"
				],
				configs: [],
				formItem: {
					id: 0,
					index: 1,
					community: "",
					type:'', 
					louceng1:'',
					louceng2:'',
					shi:'',
					ting:'',
					wei:'',
					mianji: "",
					pictures: [],
					phone: "",
					contact: "",
					price: "",
					title: "出租",
					content: "" 
				}
			};
		},

		mounted() {
			window.scrollTo(0, 0);
			this.id = this.$route.params.id
			this.formItem.id = this.id
			this.init();
		},

		methods: {
			init() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.configs = reponseData.configs;

						self.refer = reponseData.refer;
						self.islogin = reponseData.islogin;
						console.log(reponseData);
						if (self.islogin == 0) {
							self.$router.push("/login");
						}
					},
					error: function() {
						self.$toast("system error");
					}
				});
				$.ajax({
					url: self.getViewUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						id: self.id
					},
					headers: self.getRequestHeader(),
					success: (reponseData, status) => {
						console.log(reponseData.data)
						self.model = reponseData.data.model;
						self.refer = reponseData.data.refer;
						self.formItem.mianji = self.model.area
						self.formItem.price = self.model.price
						self.$refs.uploadSingle.initFile(self.model.images, self.model.pictures)
						self.formItem.community = self.model.community
						self.formItem.louceng1 = self.model.louceng1
						self.formItem.louceng2 = self.model.louceng2
						self.formItem.shi = self.model.shi ? String(self.model.shi).replace(/[^\d.]/g, '') : ''
						self.formItem.ting = self.model.ting ? String(self.model.ting).replace(/[^\d.]/g, '') : ''
						self.formItem.wei = self.model.wei ? String(self.model.wei).replace(/[^\d.]/g, '') : ''
	 
						self.formItem.content = self.model.content
						self.formItem.contact = self.model.contact
						self.formItem.phone = self.model.phone
						self.formItem.type = self.model.type
						self.formItem.pictures = self.model.pictures ? self.model.pictures : []

					},
					error: function() {
						self.$toast("system error");
					},
				});
			},

			getArea(value) {
				this.formItem.area = value;
			},
			getXiaoqu(value) {
				this.formItem.community = value;
			},
			getChaoxiang(value) {
				this.formItem.chaoxiang = value;
			},
			getLouceng(value) {
				this.formItem.louceng = value;
			},
			getMap(value) {
				this.formItem.map = value;
			},
			getHuxing(value) {
				this.formItem.huxing = value;
			},

			getType(value) {
				this.formItem.type = value;
			},
			getZhuangxiu(value) {
				this.formItem.zhuangxiu = value;
			},
			getPay(value) {
				this.formItem.pay = value;
			},

			getPictures(value) {
				this.formItem.pictures = value;
				console.log(value);
			},
			post() {
				if (this.isactive) {
					this.$toast("已经提交");
					return;
				}
				var self = this;
				self.$toast.loading({
					mask: true,
					duration: 0,
					message: "数据提交中"
				});

				$.ajax({
					url: self.getPostUrl,
					timeout: 120000,
					dataType: "json",
					type: "post",
					data: self.formItem,
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.$toast.clear();
						if (reponseData.status == 1) {
							self.isactive = true;
							self.$toast(reponseData.message);
							self.$router.push('/user/shop')
						} else {
							self.$toast(reponseData.message);
							self.isactive = false;
						}
					},
					error: function(reponseData) {
						console.log(reponseData);
						self.$toast("system error");
					}
				});
			}
		}
	};
</script>

<style scoped>
	#mapPage {
		width: 100vw;
		height: 100vh;
		display: block;
	}

	.form-img {
		font-weight: bold;
	}

	.van-checkbox-group {
		display: flex;
		flex-flow: wrap;
		background-color: #f8f8f8;
		padding: 10px 0 10px 15px;
		border-radius: 4px;
	}

	.img-box img {
		width: 80px;
		height: 80px;
	}

	.van-checkbox {
		width: 25%;
		margin: 5px 0;
	}
</style>>